<script>
    import Title from './title.svelte'
    

    // 1.635s per iteration on Colab GPU
    const REAL_FRAME_TIME = 1.635 * 25 * 1000;

    let frameNumber = 12;
    let isPlaying = false;
    let speed = REAL_FRAME_TIME / 200;

    const numOfFrames = 40;
    const frameIntArray = Array.from(new Array(numOfFrames + 1), (x,i) => i);

    let playInterval;

    function play() {
        if (!isPlaying) {
            isPlaying = true;
            playInterval = setInterval(() => {
                    frameNumber = frameNumber % (numOfFrames - 1);
                    frameNumber += 1;
                }, speed);
        }
    }

    function pause() {
        isPlaying = false;
        clearInterval(playInterval)
    }

    function changeFrame(i) {
        pause()
        frameNumber = i;
    }

    // play();

</script>

<style>

    #wrapper {
        grid-column: page;
        max-width: calc(100vw - 2em);
    }

    #frames {
		display: grid;
		grid-template-columns: repeat(11, 1fr);
        grid-column-gap: 0.2em;
        padding-top: 10px;
    }

    .frame {
        width: 100%;
        padding-bottom: 5px;
        filter: brightness(60%);
        cursor: crosshair;
    }

    .active-frame {
        border-bottom: 3px solid var(--orange);
        padding-bottom: 2px;
        filter: brightness(100%);
    }

    #training-wrapper {
        display: grid;
        grid-template-columns: repeat(12, 1fr);
        grid-column-gap: 2em;
        max-width: calc(100vw - 2em);
    }

    #training {
        grid-column-start: 1;
        grid-column-end: 7;
        width: 100%;
        border-radius: var(--border-radius);
        max-width: calc(100vw - 2em);
    }

    #training-controls {
        grid-column-start: 7;
        grid-column-end: 13;
        display: flex;
        flex-direction: column;
        justify-content: center;
        text-align: left;
        max-width: calc(100vw - 2em);
    }

    .slider {
        -webkit-appearance: none;
        appearance: none;
        outline: none;
        opacity: 0.7;
        -webkit-transition: .2s;
        transition: opacity .2s;
        height: 3px;
        border-radius: 2px;
        background-color: hsla(0, 0%, 0%, 0.2);
    }

    .slider:hover {
        opacity: 1;
    }

    .slider::-webkit-slider-thumb {
        -webkit-appearance: none; /* Override default look */
        appearance: none;
        cursor: pointer; /* Cursor on hover */
        top: -6px;
        left: -6px;
        width: 13px;
        height: 13px;
        background-color: var(--orange);
        border-radius: 50%;
    }

    .slider::-moz-range-thumb {
        top: -6px;
        left: -6px;
        width: 13px;
        height: 13px;
        background-color: var(--orange);
        cursor: pointer;
    }

    button {
        border: none;
        padding: 0;
        cursor: pointer;
        outline: inherit;
        color: var(--orange);
        background-color: var(--gray-bg);
    }

    #button-wrapper {
        display: flex;
    }

    #button-wrapper > * {
        display: flex;
        flex-direction: column;
        justify-content: center;
        margin-top: 0.5rem;
        margin-right: 0.5rem;
    }

    .caption {
		font-size: 0.8em;
		line-height: 1.5em;
		color: var(--gray);
	}

    @media(max-width: 1000px) {

        #training-controls {
            grid-column-start: 1;
            grid-column-end: 13;
            order: 1;
            margin-bottom: 0.5rem;
        }

        #training {
            grid-column-start: 1;
            grid-column-end: 13;
            order: 2;
        }

        #button-wrapper {
            justify-content: center;
        }

    }

    @media(max-width: 768px) {
        #wrapper {
            grid-column: screen;
        }

        .slider::-webkit-slider-thumb {
            top: -8px;
            left: -8px;
            width: 15px;
            height: 15px;
        }

        .slider::-moz-range-thumb {
            top: -8px;
            left: -8px;
            width: 15px;
            height: 15px;
        }
    }

</style>

<figure class="subgrid">
    <div id="wrapper" class="interactive-container">
        <div id="training-wrapper">
            <img id="training" src="images/training/iteration_{frameNumber * 25}.jpg" alt="training running."/>

            
            <div id="training-controls">
                <Title
                    titleText="Iteration: {frameNumber * 25}"
                    subtitleText="Real Time: {REAL_FRAME_TIME / 1000 * frameNumber}s"
                />
                <div class="caption">
                   A "tiny" NeRF trained on 100 viewpoints of our bulldozer randomly sampled in batches of 64 per iteration. Notably, we use a ReLU model with 9 densely connected layers of 256 outputs with the viewpoint concatenated halfway through the model architecture.
                </div>
                <div id="button-wrapper">
                    <button on:click={isPlaying ? pause : play}><i class="material-icons" style="font-size:48px;">{isPlaying ? "pause_circle_outline": "play_circle_outline"}</i></button>
                    <div><input type=range bind:value={frameNumber} min={0} max={numOfFrames} on:mousedown={pause} class="slider"></div>
                </div>
            </div>
        </div>
        <div id="frames">
            {#each frameIntArray as frameInt, i}
                    <img src="images/training/iteration_{frameInt * 25}.jpg" alt="training running." class='{frameInt === frameNumber ? "frame active-frame": "frame"}' on:mouseover={() => changeFrame(i)}
                    on:focus={() => changeFrame(i)}
                    />
            {/each}
        </div>
    </div>
    <figcaption style="grid-column: text;"><a class="figure-number" href="#training">3</a>: Click the play button or scrub over the video frames to watch and control the animation.</figcaption>
</figure>